import React from "react";
import { DataTable } from "react-native-paper";
import { TableValueCellComponent } from "./types";

export const TableDateRangeCell: TableValueCellComponent = ({
  rentalPeriodString,
}) => {
  return <DataTable.Cell>{rentalPeriodString}</DataTable.Cell>;
};
